import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IValidatePasswordResetTokenParams {
  token: string;
}

export interface IValidatePasswordResetTokenResult extends IResult {
}

export class ValidatePasswordResetTokenRequest extends Request<IValidatePasswordResetTokenParams, IValidatePasswordResetTokenResult> {
    constructor(params: IValidatePasswordResetTokenParams){
      super('validatePasswordResetToken', params);
    }
}
